import React from 'react';
import { Link } from '../root/components/Link';
import { assetPathFn } from '../util';
import styles from './DiscoverHoneylove.module.scss';

export const DiscoverHoneylove: React.FC = () => {
  return (
    <div className={styles.discoverHoneyloveCard}>
      <div>
        <Link dataTrackLabel="discover sculptwear" dataTrackLocation="cart-footer" href="/collections/sculptwear" buttonType="ghost">
          <img src={assetPathFn('sculptwear-discover.png')} alt="" />
          <div>Sculptwear</div>
        </Link>
      </div>
      <div>
        <Link dataTrackLabel="discover bras" dataTrackLocation="cart-footer" href="/collections/bras" buttonType="ghost">
          <img src={assetPathFn('bras-discover.png')} alt="" />
          <div>Bras</div>
        </Link>
      </div>
      <div>
        <Link dataTrackLabel="discover bodysuits" dataTrackLocation="cart-footer" href="/collections/bodysuits" buttonType="ghost">
          <img src={assetPathFn('bodysuit-discover.png')} alt="" />
          <div>Bodysuits</div>
        </Link>
      </div>
      <div>
        <Link dataTrackLabel="discover tops" dataTrackLocation="cart-footer" href="/collections/tops" buttonType="ghost">
          <img src={assetPathFn('tops-discover.png')} alt="" />
          <div>Tops</div>
        </Link>
      </div>
      <div>
        <Link dataTrackLabel="discover bottoms" dataTrackLocation="cart-footer" href="/collections/bottoms" buttonType="ghost">
          <img src={assetPathFn('bottoms-discover.png')} alt="" />
          <div>Bottoms</div>
        </Link>
      </div>
      <div>
        <Link dataTrackLabel="discover underwear" dataTrackLocation="cart-footer" href="/collections/underwear" buttonType="ghost">
          <img src={assetPathFn('undies-discover.png')} alt="" />
          <div>Undies</div>
        </Link>
      </div>
    </div>
  );
};

export default DiscoverHoneylove;
